var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-bar',{attrs:{"isMinimal":"","state":_vm.state,"indexes":_vm.indexes,"isIndexesLoaded":true,"isScopedSearch":true},on:{"keywordChanged":_vm.handleKeywordChange}}),_c('search-suggestion-button',{attrs:{"scope":_vm.state.key},on:{"clicked":_vm.handleKeywordChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }